import React from 'react'
import PropTypes from 'prop-types'
import './BillersView.scss'

import CONFIG from '../../../config'

import {getLanguageScope} from '../../../helpers'

const _i18n = getLanguageScope('billers');

import CategoryDefaultImage from '../../../assets/category_default_image.png'
import ListPagination from "../../shared/ListPagination/containers/ListPaginationContainer";

import {Grid, Image, Header, Button, Form, Icon, List, Segment, Input} from 'semantic-ui-react'
import _ from 'lodash'

class BillersView extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {loadFavoritesBillers} = this.props;

    loadFavoritesBillers && loadFavoritesBillers()
  }

  renderFavoritesBillers() {
    const {favorites, next} = this.props;

    const favoritesViews = _.map(favorites, (biller, key) => (
      <List.Item as='a' onClick={() => next(biller)} key={key}>
        <List.Content verticalAlign='middle'>
          <Header as={'h5'}>
            <Image size='mini'
                   src={biller.icon ? `${CONFIG.STATIC_PATH}${biller.icon}` : CategoryDefaultImage}/> {biller.biller_name}
          </Header>
        </List.Content>
      </List.Item>
    ));

    return (
      <ListPagination
        items={favoritesViews}
        itemsPerPage={10}
        noItemsMessage={_i18n('no_favorites')}
        listStyles={{"minHeight": 200}}
      />
    );
  }

  renderBillersSearchResult() {
    const {searchResult, searchStarted, next} = this.props;

    if(!searchStarted) return null;

    const resultsViews = _.map(searchResult, (biller, key) => (
      <List.Item as='a' className={'list-item'} onClick={() => next(biller)} key={key}>
        <Image avatar src={biller.icon ? `${CONFIG.STATIC_PATH}${biller.icon}` : CategoryDefaultImage}/>
        <List.Content className={'list-item-text'} verticalAlign='middle'>
          <List.Header>{biller.value}</List.Header>
          {biller.biller_city_state_zip}
        </List.Content>
      </List.Item>
    ));

    return (
      <React.Fragment>
        <Header as='h3'>{_i18n('results')}</Header>
        <ListPagination
          items={resultsViews}
          itemsPerPage={5}
          noItemsMessage={_i18n('no_results')}
          listStyles={{"minHeight": 200}}
        />
      </React.Fragment>
    );
  }


  doBillerSearch = () => {
    const {billerPOBox, billerZip, billerName, doBillersSearch} = this.props;
    if (!(billerPOBox || billerZip || billerName)) return;

    return doBillersSearch(billerPOBox, billerZip, billerName)
  };

  renderSearchForm() {
    const {changePobox, changeZip, changeBillerName, billerPOBox, billerZip, billerName, billerLoading} = this.props;

    return (
      <Form className={'search-form'} onSubmit={this.doBillerSearch}>

        <Form.Group widths='equal'>
          <Form.Field>
            <label>{_i18n('biller_name')}</label>
            <Input fluid name='biller-name' value={billerName} onChange={(e, {name, value}) => changeBillerName(value)}
                   placeholder={_i18n('biller_name_placeholder')}/>
          </Form.Field>
        </Form.Group>

        <Form.Group widths='equal'>
          <Form.Field>
            <label>{_i18n('po_box')}</label>
            <Input name='biller-po-box' value={billerPOBox} onChange={(e, {name, value}) => changePobox(value)}
                   placeholder={'XXXXX'}/>
          </Form.Field>

          <Form.Field>
            <label>{_i18n('zip')}</label>
            <Input name='biller-zip' value={billerZip} onChange={(e, {name, value}) => changeZip(value)}
                   placeholder={'XXXXX'}/>
          </Form.Field>
        </Form.Group>

        <Button id={'search-button'} className={'button-center'} disabled={billerLoading} type='submit' icon loading={billerLoading} labelPosition='right'>
          {_i18n('search')}
          <Icon name='search'/>
        </Button>
      </Form>
    )
  }

  render() {
    return (
      <Grid>
        <Grid.Row stretched columns={2}>
          <Grid.Column>
            <Grid.Row stretched columns={1}>
              <Header as='h3'>{_i18n('favorites')}</Header>
              {this.renderFavoritesBillers()}
            </Grid.Row>
          </Grid.Column>
          <Grid.Column>
            <Grid.Row stretched columns={2}>
              <Grid.Column stretched>
                <Header textAlign={'center'} as='h3'>{_i18n('biller_search')}</Header>
                {this.renderSearchForm()}
              </Grid.Column>
              <Grid.Column className={'biller-search_results'} stretched>
                {this.renderBillersSearchResult()}
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

BillersView.propTypes = {
  changePobox: PropTypes.func,
  changeZip: PropTypes.func,
  doBillersSearch: PropTypes.func,
  billerZip: PropTypes.string,
  billerPOBox: PropTypes.string,
  next: PropTypes.func
};

export default BillersView


// WEBPACK FOOTER //
// ./src/components/Billers/components/BillersView.js